import React from 'react';
import helper from '../../../Services/helper';

const ImportDataProgressBar = (params) => {
    const done = params?.progress >= 100;

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 999999,
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(4px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '28px',
        }}>
            <div style={{ textAlign: 'center' }}>
                {done ? (
                    <div style={{
                        width: '80px', height: '80px', borderRadius: '50%',
                        background: '#d1fae5', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', margin: '0 auto 16px',
                    }}>
                        <i className="fas fa-check" style={{ color: '#059669', fontSize: '34px' }} />
                    </div>
                ) : (
                    <div style={{
                        width: '80px', height: '80px', borderRadius: '50%',
                        background: '#dbeafe', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', margin: '0 auto 16px',
                    }}>
                        <i className="fas fa-cloud-upload-alt" style={{ color: '#3b82f6', fontSize: '32px' }} />
                    </div>
                )}
                <p style={{ fontSize: '20px', fontWeight: 700, color: '#111827', margin: '0 0 6px' }}>
                    {done ? 'U regjistrua me sukses' : 'Duke importuar...'}
                </p>
                <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
                    {done ? 'Të dhënat u ngarkuan me sukses.' : 'Ju lutem prisni.'}
                </p>
            </div>

            <div style={{ width: '420px' }}>
                <div style={{
                    height: '6px', background: '#e5e7eb',
                    borderRadius: '999px', overflow: 'hidden',
                }}>
                    <div style={{
                        height: '100%',
                        width: `${params?.progress}%`,
                        background: done ? '#10b981' : '#3b82f6',
                        borderRadius: '999px',
                        transition: 'width 0.3s ease, background 0.3s ease',
                    }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                    <span style={{ fontSize: '11px', color: '#9ca3af' }}>0%</span>
                    <span style={{ fontSize: '12px', fontWeight: 600, color: done ? '#059669' : '#3b82f6' }}>
                        {params?.progress}%
                    </span>
                    <span style={{ fontSize: '11px', color: '#9ca3af' }}>100%</span>
                </div>
            </div>

            {done && (
                <button
                    onClick={() => params.setProgress()}
                    style={{
                        padding: '8px 28px',
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#fff',
                        background: '#10b981',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'background .15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#059669'}
                    onMouseLeave={e => e.currentTarget.style.background = '#10b981'}
                >
                    Ruaje
                </button>
            )}
        </div>
    );
};

export default ImportDataProgressBar;
